import { render, staticRenderFns } from "./ListGeoNovation.vue?vue&type=template&id=2d1c7a8c&"
import script from "./ListGeoNovation.vue?vue&type=script&lang=js&"
export * from "./ListGeoNovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports